export const coverageAvatarColors = ['#52429A', '#008B95', '#003C69', '#006FB9', '#13A01E', '#6639B7'];